module.exports = __webpack_public_path__ + "img/wild_table.427847c9.png";